import styled from '@emotion/styled'
import { Colors } from 'src/components/theme'

export const CircleIcon = styled.span<{
  color: string
  size: number
  padding?: number
}>`
  flex: none !important;
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${(props) => props.size}px;
  min-height: ${(props) => props.size}px;
  width: ${(props) => props.size}px;
  min-width: ${(props) => props.size}px;
  border-radius: 50%;
  background-color: ${(props) => props.color};
  padding: ${(props) => props.padding || 0}px;
  svg {
    height: ${(props) => props.size / 2}px;
    color: ${Colors.bgWhite};
  }
`
